/* eslint-disable */


var DOMCreated = false;

function createPrint(elts, container, cb) {
  elts.each(function() { 
    var el = $(this).clone();

    el.appendTo(container);
  });

  DOMCreated = true;

  if (cb) cb();
}

module.exports = function(selector, containerClass) {
  var printContent = $('<div class="print-content '+ containerClass+'" />');
  var elts = $(selector);

  printContent.appendTo('body');

  if (window.matchMedia) {
    var mediaQueryList = window.matchMedia('print');
    mediaQueryList.addListener(function(mql) {
      if (mql.matches && !DOMCreated) {
        createPrint(elts, printContent);
      }
    });
  }


    window.onbeforeprint = function () {
      if (!DOMCreated) createPrint(elts, printContent);}
}
